import React from 'react';
import PropTypes from 'prop-types';
import './ChatMessage.scss';

const ChatMessage = ({ message, locale }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Función para procesar markdown simple
  const processMarkdown = (text) => {
    if (!text) return '';

    let processed = text;

    // Convertir **texto** a <strong>texto</strong>
    processed = processed.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

    // Convertir doble salto de línea a párrafo
    processed = processed.replace(/\n\n/g, '<br><br>');

    // Convertir saltos de línea simples a <br>
    processed = processed.replace(/\n/g, '<br>');

    return processed;
  };

  return (
    <div className={`chat-message chat-message--${message.sender}`}>
      <div className="chat-message__bubble">
        <div
          className="chat-message__text"
          dangerouslySetInnerHTML={{ __html: processMarkdown(message.text) }}
        />
        <span className="chat-message__time">
          {formatTime(message.timestamp)}
        </span>
      </div>
    </div>
  );
};

ChatMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    sender: PropTypes.oneOf(['user', 'bot']).isRequired,
    timestamp: PropTypes.string.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
};

export default ChatMessage;
